<template>
  <div>
    <TopoComponent></TopoComponent>
    <div class="container vertical-align login escolha mt-4 text-center">
      <div class="row">
        <form class="form-signin">
          <div>
            <h2>Agora vamos ativar a conta de seus dependentes</h2>
            <p class="text-center">Para concluir a ativação, as contas de seus dependentes também devem ser ativadas agora.</p>
            <h4 class="mt-4">Selecione um dependente:</h4>

            <div class="clearfix"></div>
            <div class="mt-4">
              <button
                class="btn btn-lg btn-primary btn-block button success"
                type="button"
                v-for="(dependente, index) in dependentes"
                :key="index"
                @click="selecionarDependente(index)"
              >
                {{ dependente.nome }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import TopoComponent from "@/components/TopoComponent";

export default {
  components: { TopoComponent },
  name: "SelecionarDependente",
  data() {
    return {
      dependentes: null,
    };
  },
  mounted: function() {
    if (sessionStorage.getItem("dependentes") != null) {
      this.dependentes = JSON.parse(sessionStorage.getItem("dependentes"));
    }
  },
  methods: {
    selecionarDependente(index) {
      this.$router.push(`/selecionar-modo-de-login-do-dependente/${index}`);
    },
  },
};
</script>

<style scoped>
.imgFalha {
  max-width: 180px;
  text-align: center;
}
.divFalha {
  text-align: center;
}
.imgContato {
  max-width: 50px;
  text-align: center;
}
.imgWhatsapp {
  max-width: 25px;
  text-align: center;
}
.imgEmail {
  max-width: 25px;
  text-align: center;
}
.mensagemFalha {
  color: gray;
  text-align: center;
  font-size: 20px;
}

.dados {
  color: darkgray;
  font-weight: bold;
  margin-top: 5px;
  line-height: 3.7;
}
</style>
